var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOtherBg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7735 3.78805L13.7766 7.63451C14.4118 8.44973 14.7108 9.43308 14.6614 10.4083C14.6318 10.9916 14.4776 11.5736 14.194 12.1169C13.4364 13.5684 11.8813 14.4979 10.1662 14.5C8.45155 14.4977 6.89693 13.5683 6.13938 12.1171C5.3835 10.6692 5.54256 8.93705 6.55568 7.63576C6.55573 7.6357 6.55578 7.63564 6.55582 7.63558L9.55878 3.78805C9.55884 3.78797 9.55891 3.78789 9.55898 3.7878C9.69765 3.61068 9.92135 3.5 10.1662 3.5C10.411 3.5 10.6347 3.6107 10.7734 3.78785C10.7734 3.78792 10.7735 3.78798 10.7735 3.78805Z",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3739_8326)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3739_8326)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.2345,
    y: 16,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.297,
    y: 16,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.3595,
    y: 16,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.42188,
    y: 16,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.48438,
    y: 16,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5469,
    y: 16,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.6094,
    y: 16,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.6719,
    y: 16,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7344,
    y: 16,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.203247,
    y: 17.0312,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.26575,
    y: 17.0312,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.32825,
    y: 17.0312,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3905,
    y: 17.0312,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.45312,
    y: 17.0312,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5156,
    y: 17.0312,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5781,
    y: 17.0312,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.6406,
    y: 17.0312,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.7031,
    y: 17.0312,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.7656,
    y: 17.0312,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.2345,
    y: 18.0625,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.297,
    y: 18.0625,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.3595,
    y: 18.0625,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.42188,
    y: 18.0625,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.48438,
    y: 18.0625,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5469,
    y: 18.0625,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.6094,
    y: 18.0625,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.6719,
    y: 18.0625,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7344,
    y: 18.0625,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.203247,
    y: 19.0938,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.26575,
    y: 19.0938,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.32825,
    y: 19.0938,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3905,
    y: 19.0938,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.45312,
    y: 19.0938,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5156,
    y: 19.0938,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5781,
    y: 19.0938,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.6406,
    y: 19.0938,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.7031,
    y: 19.0938,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.7656,
    y: 19.0938,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 16,
    width: 18,
    height: 4,
    rx: 1,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3739_8326"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 16,
    width: 18,
    height: 4,
    rx: 1,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3739_8326"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 16,
    width: 22,
    height: 4.125,
    rx: 1.375,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOtherBg);
export default ForwardRef;